import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUser, FiBell, FiShield, FiDatabase, FiZap } = FiIcons;

export default function Settings() {
  return (
    <div className="max-w-4xl mx-auto h-full flex flex-col">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-white tracking-tight">System Configuration</h1>
        <p className="text-gray-400 text-sm mt-1">Manage user preferences and workspace integrations.</p>
      </div>

      <div className="flex flex-col md:flex-row gap-8 flex-1 overflow-hidden">
        {/* Settings Navigation */}
        <div className="w-full md:w-64 space-y-1 shrink-0">
          {[
            { id: 'profile', label: 'Profile & Account', icon: FiUser, active: true },
            { id: 'notifications', label: 'Alerts & Rules', icon: FiBell },
            { id: 'integrations', label: 'Integrations', icon: FiZap },
            { id: 'security', label: 'Security', icon: FiShield },
            { id: 'data', label: 'Data Management', icon: FiDatabase },
          ].map(item => (
            <button
              key={item.id}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-all text-left ${
                item.active 
                  ? 'bg-cyan-400/10 text-cyan-400 border border-cyan-400/30 shadow-[inset_0_0_10px_rgba(0,240,255,0.05)]' 
                  : 'text-gray-400 hover:text-white hover:bg-white/5'
              }`}
            >
              <SafeIcon icon={item.icon} />
              {item.label}
            </button>
          ))}
        </div>

        {/* Settings Content Area */}
        <div className="flex-1 glass-panel rounded-xl p-6 md:p-8 overflow-y-auto scrollbar-custom">
          <h2 className="text-lg font-medium text-white mb-6 border-b border-matrix-border/30 pb-4">Profile Information</h2>
          
          <div className="flex items-center gap-6 mb-8">
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=150&q=80" 
                alt="Profile" 
                className="w-24 h-24 rounded-full border-2 border-cyan-400/50 object-cover"
              />
              <button className="absolute bottom-0 right-0 w-8 h-8 rounded-full bg-violet-900 border border-cyan-400 flex items-center justify-center text-cyan-400 hover:bg-cyan-400 hover:text-black transition-colors">
                <SafeIcon icon={FiUser} className="text-sm" />
              </button>
            </div>
            <div>
              <h3 className="text-white font-medium">Alex Vance</h3>
              <p className="text-gray-400 text-sm font-mono">alex.vance@company.com</p>
              <span className="inline-block mt-2 px-2 py-1 rounded bg-violet-900/50 text-xs text-violet-300 border border-violet-700/50 font-mono">WORKSPACE ADMIN</span>
            </div>
          </div>

          <form className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <label className="text-xs font-mono text-gray-400 uppercase">Full Name</label>
                <input type="text" defaultValue="Alex Vance" className="w-full bg-black/30 border border-matrix-border/50 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-cyan-400 focus:shadow-neon transition-all" />
              </div>
              <div className="space-y-2">
                <label className="text-xs font-mono text-gray-400 uppercase">Role</label>
                <input type="text" defaultValue="Product Lead" className="w-full bg-black/30 border border-matrix-border/50 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-cyan-400 focus:shadow-neon transition-all" />
              </div>
            </div>
            
            <div className="space-y-2">
              <label className="text-xs font-mono text-gray-400 uppercase">Bio / Status</label>
              <textarea rows="3" defaultValue="Focused on Q3 deliverables." className="w-full bg-black/30 border border-matrix-border/50 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-cyan-400 focus:shadow-neon transition-all resize-none"></textarea>
            </div>

            <div className="pt-6 border-t border-matrix-border/30 flex justify-end gap-3">
              <button type="button" className="px-4 py-2 rounded-lg text-sm text-gray-400 hover:text-white transition-colors">Cancel</button>
              <button type="button" className="px-6 py-2 rounded-lg text-sm bg-cyan-400 text-black font-medium hover:bg-cyan-300 hover:shadow-neon transition-all">Save Changes</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}